// ChecklistSectionCard.jsx
import { Card } from "@mui/material";
import { green, grey, orange, red } from "@mui/material/colors";
import { isNil } from "lodash";
import { memo, useCallback, useMemo } from "react";

export const ChecklistSectionCard = memo(({ children, sectionStats, sx }) => {
  const getColor = useCallback((stats) => {
    if (isNil(stats)) return grey[800];
    if (stats.isCompleted) return green[800];
    if (stats.failedCount > 0) return red[700];
    if (stats.exceptionRequestedCount > 0) return orange[800];
    return grey[800];
  }, []);

  const styles = useMemo(() => {
    return {
      mb: 2,
      p: 0,
      boxShadow: "none",
      border: "1px solid #dde1e7",
      background: "#ffffff",
      transition: "100ms",
      "h3.checklist-section-title": {
        color: getColor(sectionStats),
      },
      "&:hover": {
        boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
      },
      ...sx,
    };
  }, [sx, sectionStats, getColor]);

  return (
    <Card variant="outlined" sx={styles}>
      {children}
    </Card>
  );
});
